import { styled } from "./styled.js";
/// Internal API to create styled components
/// Optimization for faster rendering and smaller bundle size in production
/// thanks to better minification and dead code elimination
///
/// List taken from https://github.com/styled-components/styled-components/blob/e0019ba666fab4b5aaa2bff71ba6ad0005a299fd/packages/styled-components/src/utils/domElements.ts#L90
export const __yak_a = /*#__PURE__*/ styled("a");
export const __yak_abbr = /*#__PURE__*/ styled("abbr");
export const __yak_address = /*#__PURE__*/ styled("address");
export const __yak_area = /*#__PURE__*/ styled("area");
export const __yak_article = /*#__PURE__*/ styled("article");
export const __yak_aside = /*#__PURE__*/ styled("aside");
export const __yak_audio = /*#__PURE__*/ styled("audio");
export const __yak_b = /*#__PURE__*/ styled("b");
export const __yak_base = /*#__PURE__*/ styled("base");
export const __yak_bdi = /*#__PURE__*/ styled("bdi");
export const __yak_bdo = /*#__PURE__*/ styled("bdo");
export const __yak_big = /*#__PURE__*/ styled("big");
export const __yak_blockquote = /*#__PURE__*/ styled("blockquote");
export const __yak_body = /*#__PURE__*/ styled("body");
export const __yak_br = /*#__PURE__*/ styled("br");
export const __yak_button = /*#__PURE__*/ styled("button");
export const __yak_canvas = /*#__PURE__*/ styled("canvas");
export const __yak_caption = /*#__PURE__*/ styled("caption");
export const __yak_cite = /*#__PURE__*/ styled("cite");
export const __yak_code = /*#__PURE__*/ styled("code");
export const __yak_col = /*#__PURE__*/ styled("col");
export const __yak_colgroup = /*#__PURE__*/ styled("colgroup");
export const __yak_data = /*#__PURE__*/ styled("data");
export const __yak_datalist = /*#__PURE__*/ styled("datalist");
export const __yak_dd = /*#__PURE__*/ styled("dd");
export const __yak_del = /*#__PURE__*/ styled("del");
export const __yak_details = /*#__PURE__*/ styled("details");
export const __yak_dfn = /*#__PURE__*/ styled("dfn");
export const __yak_dialog = /*#__PURE__*/ styled("dialog");
export const __yak_div = /*#__PURE__*/ styled("div");
export const __yak_dl = /*#__PURE__*/ styled("dl");
export const __yak_dt = /*#__PURE__*/ styled("dt");
export const __yak_em = /*#__PURE__*/ styled("em");
export const __yak_embed = /*#__PURE__*/ styled("embed");
export const __yak_fieldset = /*#__PURE__*/ styled("fieldset");
export const __yak_figcaption = /*#__PURE__*/ styled("figcaption");
export const __yak_figure = /*#__PURE__*/ styled("figure");
export const __yak_footer = /*#__PURE__*/ styled("footer");
export const __yak_form = /*#__PURE__*/ styled("form");
export const __yak_h1 = /*#__PURE__*/ styled("h1");
export const __yak_h2 = /*#__PURE__*/ styled("h2");
export const __yak_h3 = /*#__PURE__*/ styled("h3");
export const __yak_h4 = /*#__PURE__*/ styled("h4");
export const __yak_h5 = /*#__PURE__*/ styled("h5");
export const __yak_h6 = /*#__PURE__*/ styled("h6");
export const __yak_header = /*#__PURE__*/ styled("header");
export const __yak_hgroup = /*#__PURE__*/ styled("hgroup");
export const __yak_hr = /*#__PURE__*/ styled("hr");
export const __yak_html = /*#__PURE__*/ styled("html");
export const __yak_i = /*#__PURE__*/ styled("i");
export const __yak_iframe = /*#__PURE__*/ styled("iframe");
export const __yak_img = /*#__PURE__*/ styled("img");
export const __yak_input = /*#__PURE__*/ styled("input");
export const __yak_ins = /*#__PURE__*/ styled("ins");
export const __yak_kbd = /*#__PURE__*/ styled("kbd");
export const __yak_keygen = /*#__PURE__*/ styled("keygen");
export const __yak_label = /*#__PURE__*/ styled("label");
export const __yak_legend = /*#__PURE__*/ styled("legend");
export const __yak_li = /*#__PURE__*/ styled("li");
export const __yak_link = /*#__PURE__*/ styled("link");
export const __yak_main = /*#__PURE__*/ styled("main");
export const __yak_map = /*#__PURE__*/ styled("map");
export const __yak_mark = /*#__PURE__*/ styled("mark");
export const __yak_menu = /*#__PURE__*/ styled("menu");
export const __yak_menuitem = /*#__PURE__*/ styled("menuitem");
export const __yak_meta = /*#__PURE__*/ styled("meta");
export const __yak_meter = /*#__PURE__*/ styled("meter");
export const __yak_nav = /*#__PURE__*/ styled("nav");
export const __yak_noscript = /*#__PURE__*/ styled("noscript");
export const __yak_object = /*#__PURE__*/ styled("object");
export const __yak_ol = /*#__PURE__*/ styled("ol");
export const __yak_optgroup = /*#__PURE__*/ styled("optgroup");
export const __yak_option = /*#__PURE__*/ styled("option");
export const __yak_output = /*#__PURE__*/ styled("output");
export const __yak_p = /*#__PURE__*/ styled("p");
export const __yak_param = /*#__PURE__*/ styled("param");
export const __yak_picture = /*#__PURE__*/ styled("picture");
export const __yak_pre = /*#__PURE__*/ styled("pre");
export const __yak_progress = /*#__PURE__*/ styled("progress");
export const __yak_q = /*#__PURE__*/ styled("q");
export const __yak_rp = /*#__PURE__*/ styled("rp");
export const __yak_rt = /*#__PURE__*/ styled("rt");
export const __yak_ruby = /*#__PURE__*/ styled("ruby");
export const __yak_s = /*#__PURE__*/ styled("s");
export const __yak_samp = /*#__PURE__*/ styled("samp");
export const __yak_script = /*#__PURE__*/ styled("script");
export const __yak_section = /*#__PURE__*/ styled("section");
export const __yak_select = /*#__PURE__*/ styled("select");
export const __yak_small = /*#__PURE__*/ styled("small");
export const __yak_source = /*#__PURE__*/ styled("source");
export const __yak_span = /*#__PURE__*/ styled("span");
export const __yak_strong = /*#__PURE__*/ styled("strong");
export const __yak_style = /*#__PURE__*/ styled("style");
export const __yak_sub = /*#__PURE__*/ styled("sub");
export const __yak_summary = /*#__PURE__*/ styled("summary");
export const __yak_sup = /*#__PURE__*/ styled("sup");
export const __yak_table = /*#__PURE__*/ styled("table");
export const __yak_tbody = /*#__PURE__*/ styled("tbody");
export const __yak_td = /*#__PURE__*/ styled("td");
export const __yak_textarea = /*#__PURE__*/ styled("textarea");
export const __yak_tfoot = /*#__PURE__*/ styled("tfoot");
export const __yak_th = /*#__PURE__*/ styled("th");
export const __yak_thead = /*#__PURE__*/ styled("thead");
export const __yak_time = /*#__PURE__*/ styled("time");
export const __yak_tr = /*#__PURE__*/ styled("tr");
export const __yak_track = /*#__PURE__*/ styled("track");
export const __yak_u = /*#__PURE__*/ styled("u");
export const __yak_ul = /*#__PURE__*/ styled("ul");
export const __yak_use = /*#__PURE__*/ styled("use");
export const __yak_var = /*#__PURE__*/ styled("var");
export const __yak_video = /*#__PURE__*/ styled("video");
export const __yak_wbr = /*#__PURE__*/ styled("wbr");
export const __yak_circle = /*#__PURE__*/ styled("circle");
export const __yak_clipPath = /*#__PURE__*/ styled("clipPath");
export const __yak_defs = /*#__PURE__*/ styled("defs");
export const __yak_ellipse = /*#__PURE__*/ styled("ellipse");
export const __yak_foreignObject = /*#__PURE__*/ styled("foreignObject");
export const __yak_g = /*#__PURE__*/ styled("g");
export const __yak_image = /*#__PURE__*/ styled("image");
export const __yak_line = /*#__PURE__*/ styled("line");
export const __yak_linearGradient = /*#__PURE__*/ styled("linearGradient");
export const __yak_marker = /*#__PURE__*/ styled("marker");
export const __yak_mask = /*#__PURE__*/ styled("mask");
export const __yak_path = /*#__PURE__*/ styled("path");
export const __yak_pattern = /*#__PURE__*/ styled("pattern");
export const __yak_polygon = /*#__PURE__*/ styled("polygon");
export const __yak_polyline = /*#__PURE__*/ styled("polyline");
export const __yak_radialGradient = /*#__PURE__*/ styled("radialGradient");
export const __yak_rect = /*#__PURE__*/ styled("rect");
export const __yak_stop = /*#__PURE__*/ styled("stop");
export const __yak_svg = /*#__PURE__*/ styled("svg");
export const __yak_text = /*#__PURE__*/ styled("text");
export const __yak_tspan = /*#__PURE__*/ styled("tspan");
